import { useApp, useService, useSession } from "contexts";
import { IUser } from "interfaces";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageType, SessionType } from "types";
import { Enums, Routes, Secrets } from "utils";

export const useResetPassword = (id: string) => {
  const navigate = useNavigate();

  const { login } = useSession();
  const { setFeedback, t } = useApp();
  const { emailService, userService } = useService();

  const [password, setPassword] = useState<string>("");
  const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false);

  const handlePasswordChange = (newPassword: string) => {
    setPassword(newPassword);
  };

  const handlePasswordValid = (valid: boolean) => {
    setIsPasswordValid(valid);
  };

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();

    const response = await userService.update({ _id: id, password: Secrets.hash(password), role: "user" } as IUser);

    if (response) {
      // TODO : send email
      emailService.passwordUpdated(
        response.email,
        t.message.subject.password_updated,
        response._id,
        response.role
      );

      login({ id: response._id, email: response.email, name: response.full_name, role: response.role, settings: response.settings } as SessionType);

      setFeedback({
        message: t.message.feedback.request_update_success,
        severity: Enums.EnumFeedback.Success,
      } as MessageType);
    }

    navigate(Routes.home);
  }

  return {
    password,
    isPasswordValid,
    handlePasswordChange,
    handlePasswordValid,
    handleSubmit,
  };
};
